import React from 'react'
import { TemplateContent, TemplateWrapper } from './styles'
import SideMenu from 'pages/components/Template/components/SideMenu'
import Security from 'pages/components/Security'
import { Address, User } from 'globals/models/User'

interface IProps {
  noPadding?: boolean,
  noScroll?: boolean,
  activeMenu?: string,
  children: (currentUser: User, currentCenters: Address[]) => React.ReactNode
}

const Template = (props: IProps) => {
  const { noPadding, noScroll, activeMenu, children } = props

  return (
    <TemplateWrapper>
      <Security>
        {(currentUser, currentCenters) =>
          <>
            <SideMenu
              activeItem={activeMenu}
              addresses={currentUser.addresses}
              currentCenters={currentCenters}
            />

            <TemplateContent
              id="TemplateContent"
              noPadding={noPadding || false}
              noScroll={noScroll || false}
            >
              {children(currentUser, currentCenters)}
            </TemplateContent>
          </>
        }
      </Security>
    </TemplateWrapper>
  )
}

export default Template
